import React from 'react';
import Skills from '../components/sections/Skills';
import styled from 'styled-components';

const SkillsPage = () => {
    return (
        <PageContainer>
            <Skills />
        </PageContainer>
    );
};

const PageContainer = styled.div`
  padding-top: 80px; // To account for fixed header
`;

export default SkillsPage;
